import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './i18n'; // Import the i18n configuration
import { Suspense } from 'react'; // Needed for translations to load

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Suspense fallback="Loading..."> {/* Shows a fallback while translations are loading */}
      <App />
    </Suspense>
  </React.StrictMode>
); 
